import { client as apiClient } from '../api/client';
import { Category } from '../models/Category';

export class CategoryRepository {
  public async fetchAll(): Promise<Array<Category>> {
    return apiClient.get<Category>(`categories`, this.buildCategory);
  }

  private buildCategory = (data: Partial<Category>): Category => {
    return new Category(
      data.id as number,
      data.name as string,
      data.children ? data.children.map(this.buildCategory) : [],
      undefined,
      data.image,
      data.description
    );
  };
}

let RepositoryClass: ImportedModule<Constructable<CategoryRepository>>;
if (process.env.REACT_APP_NO_BACKEND === 'true') {
  RepositoryClass = require('./CategoryMock');
} else {
  RepositoryClass = { default: CategoryRepository };
}

let repository: CategoryRepository;
export default function getRepository() {
  if (!repository) {
    repository = new RepositoryClass.default();
  }

  return repository;
}



// WEBPACK FOOTER //
// ./src/app/repositories/Category.ts